module.exports = __webpack_public_path__ + "media/images/icook-logo-w@2x-d157dc100bafe9049c3278f1a82b51d9.png";